// frontend/src/constants/index.js
/**
 * General application constants.
 */

// Application version
export const APP_VERSION = '0.4.4';

// User roles
export const ROLES = {
  ADMIN: 'admin',
  OFFICE: 'office',
  STANDARD: 'standard',
  DEV: 'dev'
};

// Appointment statuses
export const APPOINTMENT_STATUS = {
  PLANNED: 'planned',
  ASSIGNED: 'assigned',
  EN_ROUTE: 'en-route',
  IN_PROGRESS: 'in-progress',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled'
};

// Status labels in German
export const APPOINTMENT_STATUS_LABELS = {
  [APPOINTMENT_STATUS.PLANNED]: 'Geplant',
  [APPOINTMENT_STATUS.ASSIGNED]: 'Zugewiesen',
  [APPOINTMENT_STATUS.EN_ROUTE]: 'Unterwegs',
  [APPOINTMENT_STATUS.IN_PROGRESS]: 'In Arbeit',
  [APPOINTMENT_STATUS.COMPLETED]: 'Abgeschlossen',
  [APPOINTMENT_STATUS.CANCELLED]: 'Abgesagt'
};

// Status colors
export const APPOINTMENT_STATUS_COLORS = {
  [APPOINTMENT_STATUS.PLANNED]: '#9e9e9e',
  [APPOINTMENT_STATUS.ASSIGNED]: '#2196f3',
  [APPOINTMENT_STATUS.EN_ROUTE]: '#ff9800',
  [APPOINTMENT_STATUS.IN_PROGRESS]: '#4caf50',
  [APPOINTMENT_STATUS.COMPLETED]: '#66bb6a',
  [APPOINTMENT_STATUS.CANCELLED]: '#f44336'
};

// Appointment visibility levels
export const VISIBILITY = {
  PUBLIC: 'public',
  TEAM: 'team',
  PRIVATE: 'private'
};

// Visibility labels in German
export const VISIBILITY_LABELS = {
  [VISIBILITY.PUBLIC]: 'Öffentlich',
  [VISIBILITY.TEAM]: 'Team',
  [VISIBILITY.PRIVATE]: 'Privat'
};

// Work entry statuses
export const WORK_STATUS = {
  DRAFT: 'draft',
  SUBMITTED: 'submitted',
  APPROVED: 'approved',
  REJECTED: 'rejected'
};

// Work status labels in German
export const WORK_STATUS_LABELS = {
  [WORK_STATUS.DRAFT]: 'Entwurf',
  [WORK_STATUS.SUBMITTED]: 'Eingereicht',
  [WORK_STATUS.APPROVED]: 'Genehmigt',
  [WORK_STATUS.REJECTED]: 'Abgelehnt'
};

// Work item categories
export const WORK_CATEGORIES = {
  APPOINTMENT: 'appointment',
  PREPARATION: 'preparation',
  OFFICE: 'office',
  TRAVEL: 'travel',
  OTHER: 'other'
};

// Work category labels in German
export const WORK_CATEGORY_LABELS = {
  [WORK_CATEGORIES.APPOINTMENT]: 'Termin',
  [WORK_CATEGORIES.PREPARATION]: 'Vorbereitung',
  [WORK_CATEGORIES.OFFICE]: 'Büro',
  [WORK_CATEGORIES.TRAVEL]: 'Reise',
  [WORK_CATEGORIES.OTHER]: 'Sonstiges'
};

// Invoice statuses
export const INVOICE_STATUS = {
  DRAFT: 'draft',
  SENT: 'sent',
  PAID: 'paid',
  OVERDUE: 'overdue',
  CANCELLED: 'cancelled'
};

// Invoice status labels in German
export const INVOICE_STATUS_LABELS = {
  [INVOICE_STATUS.DRAFT]: 'Entwurf',
  [INVOICE_STATUS.SENT]: 'Versendet',
  [INVOICE_STATUS.PAID]: 'Bezahlt',
  [INVOICE_STATUS.OVERDUE]: 'Überfällig',
  [INVOICE_STATUS.CANCELLED]: 'Storniert'
};

// Recurrence frequencies
export const RECURRENCE_FREQUENCY = {
  DAILY: 'daily',
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
  YEARLY: 'yearly'
};

// Recurrence frequency labels in German
export const RECURRENCE_FREQUENCY_LABELS = {
  [RECURRENCE_FREQUENCY.DAILY]: 'Täglich',
  [RECURRENCE_FREQUENCY.WEEKLY]: 'Wöchentlich',
  [RECURRENCE_FREQUENCY.MONTHLY]: 'Monatlich',
  [RECURRENCE_FREQUENCY.YEARLY]: 'Jährlich'
};

// Recurrence scope
export const RECURRENCE_SCOPE = {
  THIS: 'this',
  FUTURE: 'future',
  ALL: 'all'
};

// Date formats
export const DATE_FORMAT = 'dd.MM.yyyy';
export const TIME_FORMAT = 'HH:mm';
export const DATETIME_FORMAT = 'dd.MM.yyyy HH:mm';

// Pagination
export const DEFAULT_PAGE_SIZE = 50;
export const PAGE_SIZE_OPTIONS = [25, 50, 100, 200];

// File upload limits
export const MAX_FILE_SIZE_MB = 10;
export const MAX_ATTACHMENTS = 10;
export const ALLOWED_FILE_EXTENSIONS = [
  '.pdf', '.jpg', '.jpeg', '.png',
  '.doc', '.docx', '.txt',
  '.xlsx', '.xls'
];

// Weekdays (0 = Sunday in JavaScript)
export const WEEKDAYS_DE = {
  0: 'Sonntag',
  1: 'Montag',
  2: 'Dienstag',
  3: 'Mittwoch',
  4: 'Donnerstag',
  5: 'Freitag',
  6: 'Samstag'
};

// Default work hours
export const DEFAULT_WORK_HOURS = {
  START: '09:00',
  END: '17:00',
  WEEKLY_HOURS: 38.0
};

// Notification types
export const NOTIFICATION_TYPE = {
  APPOINTMENT_ASSIGNED: 'appointment_assigned',
  APPOINTMENT_UPDATED: 'appointment_updated',
  REPORT_SUBMITTED: 'report_submitted',
  WORK_ENTRY_APPROVED: 'work_entry_approved',
  WORK_ENTRY_REJECTED: 'work_entry_rejected',
  INVOICE_CREATED: 'invoice_created',
  VERSION_UPDATE: 'version_update'
};

// Local storage keys
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'auth_token',
  USER_PREFERENCES: 'user_preferences',
  THEME: 'theme'
};
